export default (phoneNumber) => {
  if (!phoneNumber) return null;
  if (phoneNumber === "Unavailable") return null;

  let cleaned = phoneNumber.replace(/[^\d]+/g, "").replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, "($2) $3-$4");

  return phoneNumber.match(/[+]1/g) ? cleaned || phoneNumber : phoneNumber;
};
